// @ts-strict-ignore
import React from "react";
import styled from "styled-components";

import { Paragraph3 } from "../Typography/cryptopedia";
import NextLink from "../NextLink";

const TextContainer = styled.span`
  border: 1px solid ${({ theme }) => theme.borderColors.secondary};
  padding: 2px 8px;
  border-radius: 8px;
  overflow: hidden;

  &:hover {
    background-color: ${({ theme }) => theme.backgroundColors.secondary};
    transition: background-color 0.4s ease;
  }
`;

const CryptopediaTopicTag = ({ text, href }) => (
  <NextLink href={href}>
    <Paragraph3
      css={`
        margin: 8px 0;
      `}
    >
      <TextContainer>{text}</TextContainer>
    </Paragraph3>
  </NextLink>
);

export default CryptopediaTopicTag;
